import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';

export interface IPrediction {
  probability: number;
  tagId: string;
  tagName: string;
}
export interface ICustomVisionResponse {
  id: string;
  project: string;
  iteration: string;
  created: Date;
  predictions: IPrediction[];
}

@Injectable({
  providedIn: 'root'
})
export class CustomVisionService {

  constructor(private http: HttpClient) { }

  predict(file: Blob | File) {
    const predictionKey = environment.customVisionService.predictionKey;
    const apiUrl = `${environment.customVisionService.apiUrl}`;
    const headers = new HttpHeaders({
      'Prediction-Key': predictionKey,
      'Content-Type': 'application/octet-stream',
    });
    return this.http.post<ICustomVisionResponse>(apiUrl, file, { headers });
  }

}
